module.exports = __webpack_public_path__ + "static/media/productos_pepita_blanca_tostada.43fc628f.jpg";